import ContentCopyIcon from '@mui/icons-material/ContentCopy';

const icons = {
    ContentCopyIcon
};

const DuplicatedCalims = {
    id: 'Duplicate_calims',
    type: 'group',
    children: [
        {
            id: 'Duplicate_Calims',
            title: 'Duplicate Claims',
            type: 'item',
            url: '/duplicate_calims',
            icon: icons.ContentCopyIcon,
        }
    ]
};

export default DuplicatedCalims;